import React from 'react';
type BandProps = {
  id?: string;
  eyebrow: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Optional content for the right of the section intro, so headers never leave half the viewport empty. */
  aside?: React.ReactNode;
  dark?: boolean;
  children: React.ReactNode;
};
export const EYEBROW = 'font-mono text-xs uppercase tracking-[0.2em]';
export function Band({
  id,
  eyebrow,
  title,
  description,
  aside,
  dark = false,
  children
}: BandProps) {
  return <section id={id} className={dark ? 'w-full scroll-mt-20 bg-ink text-bone' : 'w-full scroll-mt-20 border-b border-mist bg-bone text-ink'} data-id="element-13" data-mp="2qav3b2rlpifl">
      <div className="mx-auto w-full max-w-6xl px-6 py-24 lg:px-10 lg:py-36" data-id="element-14" data-mp="2ckhvr1img5qs">
        <header className={aside ? 'grid gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:items-end lg:gap-16' : ''} data-id="element-15" data-mp="2hj2vkztyonep">
          <div data-id="element-16" data-mp="22m21wqs7midl">
            <p className={`${EYEBROW} ${dark ? 'text-teal-light' : 'text-teal'}`} data-id="element-17" data-mp="22liui406rcdt">
              {eyebrow}
            </p>
            <h2 className="mt-5 max-w-3xl font-display text-[34px] font-light leading-[1.08] tracking-tight sm:text-5xl" data-id="element-18" data-mp="27loj1bb5siro">
              {title}
            </h2>
            {description ? <p className={`mt-6 max-w-[68ch] text-xl leading-relaxed ${dark ? 'text-bone/70' : 'text-graphite'}`} data-id="element-19" data-mp="135gtcrc8ziyc">
                {description}
              </p> : null}
          </div>
          {aside ? <div data-id="element-20" data-mp="1d4o4d7vif1ia">{aside}</div> : null}
        </header>
        <div className="mt-14" data-id="element-21" data-mp="pdsisshnd2jh">{children}</div>
      </div>
    </section>;
}
type PullQuoteProps = {
  children: React.ReactNode;
  dark?: boolean;
};
export function PullQuote({
  children,
  dark = false
}: PullQuoteProps) {
  return <p className={`border-l-2 pl-6 font-display text-2xl font-light leading-snug ${dark ? 'border-teal-light/50 text-bone/85' : 'border-teal text-ink'}`} data-id="element-22" data-mp="y7f8c0v9h9k8">
      {children}
    </p>;
}